import React from 'react';
import PropTypes from 'prop-types';
import { RouterLinkStyled, LinkStyled, StyledIcon } from './styles/LinkStyled';

const Link = ({
  to,
  href,
  children,
  iconName,
  iconColor,
  title,
  target,
  type,
  background,
  iconSize,
  iconHeight,
  iconWidth,
  transform,
  textColor,
  hoverColor,
  textSize,
  className,
  referrerPolicy,
}) => {
  if (to) {
    return (
      <RouterLinkStyled
        className={className}
        type={type}
        to={to}
        icon={iconName}
        title={title}
        transform={transform}
        color={textColor}
        hover={hoverColor}
        size={textSize}
      >
        {iconName && <StyledIcon name={iconName} color={iconColor} size={iconSize} />}
        {children}
      </RouterLinkStyled>
    );
  }
  if (type === 'social') {
    return (
      <LinkStyled
        className={className}
        type={type}
        href={href}
        icon={iconName}
        title={title}
        target={target}
        transform={transform}
        color={textColor}
        hover={hoverColor}
        size={textSize}
      >
        {iconName && <StyledIcon name={iconName} color={iconColor} size={iconSize} />}
        {children}
      </LinkStyled>
    );
  }
  if (type === 'logo') {
    return (
      <LinkStyled
        className={className}
        type={type}
        href={href}
        icon={iconName}
        title={title}
        target={target}
        transform={transform}
        color={textColor}
        hover={hoverColor}
        size={textSize}
        style={{
          backgroundColor: background,
        }}
      >
        {iconName && (
          <StyledIcon
            name={iconName}
            color={iconColor}
            width={iconWidth}
            height={iconHeight}
            viewBox="none"
          />
        )}
        {children}
      </LinkStyled>
    );
  }
  return (
    <LinkStyled
      className={className}
      type={type}
      href={href}
      icon={iconName}
      title={title}
      target={target}
      transform={transform}
      color={textColor}
      hover={hoverColor}
      size={textSize}
      style={{
        backgroundColor: background,
      }}
      referrerPolicy={referrerPolicy}
    >
      {iconName && <StyledIcon name={iconName} color={iconColor} size={iconSize} />}
      {children}
    </LinkStyled>
  );
};

Link.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.string,
  background: PropTypes.string,
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
  iconSize: PropTypes.number,
  transform: PropTypes.string,
  textColor: PropTypes.string,
  hoverColor: PropTypes.string,
  textSize: PropTypes.string,
  className: PropTypes.string,
  referrerPolicy: PropTypes.string,
};

Link.defaultProps = {
  to: null,
  href: '',
  iconName: '',
  title: null,
  target: '_blank',
  children: null,
  type: null,
  iconColor: 'white',
  background: '',
  iconHeight: null,
  iconWidth: null,
  iconSize: null,
  transform: null,
  textColor: '',
  hoverColor: '',
  textSize: null,
  className: '',
  referrerPolicy: '',
};

export default Link;
